<script setup lang="ts">
import { useCarousel } from '@/components/ui/carousel/useCarousel';

const { carouselApi } = useCarousel();

const scrollSnaps = ref<number[]>([]);
const selectedIndex = ref(0);

watch(
  carouselApi,
  (api) => {
    if (!api) return;
    scrollSnaps.value = api.scrollSnapList();
    selectedIndex.value = api.selectedScrollSnap();
    api.on('select', () => {
      selectedIndex.value = api.selectedScrollSnap();
    });
    api.on('reInit', () => {
      scrollSnaps.value = api.scrollSnapList();
    });
  },
  { immediate: true },
);

const snapCount = computed(() => scrollSnaps.value.length);
const dots = useCarouselWindow(snapCount, selectedIndex);
</script>

<template>
  <div
    v-if="snapCount > 1"
    class="hidden items-center justify-center gap-1.5 lg:flex"
    role="tablist"
    :aria-label="$t('components.carousel.dotsLabel')"
  >
    <button
      v-for="dot in dots"
      :key="dot.index"
      role="tab"
      :aria-selected="selectedIndex === dot.index"
      :aria-label="`${$t('components.carousel.dotLabel')} ${dot.index + 1} / ${snapCount}`"
      class="rounded-full transition-all duration-300"
      :class="{
        'h-1.5 w-6 bg-brand-primary-700': dot.size === 'active',
        'size-1.5 bg-gray-300 hover:bg-gray-400': dot.size === 'normal',
        'size-1 bg-gray-300': dot.size === 'small',
      }"
      @click="carouselApi?.scrollTo(dot.index)"
    />
  </div>
</template>
